export const TEACHER_STATUS_OPTIONS = [
  { id: "Active", label: "Active" },
  { id: "goon", label: "Probation" },
  { id: "summer-break", label: "Summer Break" },
  { id: "leaving", label: "Leaving" },
  { id: "Left School", label: "Left School" },
];

export const matchesTeacherStatusFilters = (
  teacher,
  selectedStatuses = [],
  showLeftSchool = false
) => {
  const status = String(teacher?.Status || "").trim();
  const statuses = Array.isArray(selectedStatuses) ? selectedStatuses : [];
  const statusMatch = statuses.length === 0 || statuses.includes(status);
  const leftSchoolMatch = showLeftSchool || status !== "Left School";

  return statusMatch && leftSchoolMatch;
};
